import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatRippleModule } from '@angular/material/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';

import { MembershipButtonService } from './membership-button/membership-button.service';

import { MembershipButtonComponent } from './membership-button/membership-button.component';

const MODULES = [
  CommonModule,
  RouterModule,
  MatRippleModule,
  MatProgressSpinnerModule,
  TranslateModule
];

const PROVIDERS = [
  MembershipButtonService
];

const COMPONENTS = [
  MembershipButtonComponent
];

@NgModule({
  imports: [
    ...MODULES
  ],
  providers: [
    ...PROVIDERS
  ],
  declarations: [
    ...COMPONENTS
  ],
  exports: [
    MembershipButtonComponent
  ]
})
export class PartnerWebUiMembershipButtonModule {}
